import { Colors } from "../constants/colors";

export default {
  styleOverrides: {
    root: {
      ".MuiPaper-root": {
        width: "600px",
        borderRadius: "4px",
        background: Colors.WHITE,
        boxShadow: "0px 0px 12px 3px rgba(0, 0, 0, 0.20)",
        "& .MuiDialogTitle-root": {
          height: "48px",
          padding: "0px 12px 0px 20px",
          borderRadius: "3px 4px 0px 0px",
          background: Colors.WHITE,
          boxShadow: "0px 2px 4px 0px rgba(183, 183, 183, 0.20)",
          "& .MuiIconButton-root": {
            padding: "0px",
          },
        },
        "& .MuiDialogContent-root": {
          minHeight: "120px",
          padding: "0px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        "& .MuiDialogActions-root": {
          height: "58px",
          padding: "0px 20px",
          justifyContent: "flex-start",
          boxShadow: "0px -2px 4px 0px rgba(183, 183, 183, 0.20)",
          "& .MuiButton-root": {
            height: "30px",
            padding: "0px 16px",
            border: `1px solid ${Colors.GREY300}`,
          },
        },
      },
    },
  },
};
